import { ReactNode, useState ,useEffect } from 'react';
import { Navigate } from 'react-router-dom';
// components
import { LoadingScreen } from '../../components/loading-screen';
import { useAuthContext } from '../hooks';
import { PATH_AFTER_LOGIN } from 'src/config-global';
import { ROLES } from 'src/utils/constants/constants';
import { routePrefix } from 'src/utils/methods/StandardMethods';
// // routes
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useRouter, useSearchParams } from 'src/routes/hooks';
import TwoFactorAuth from 'src/pages/mfa/TwoFactorAuth';
// // ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  console.log('hi 333333333333333333')
  const router = useRouter();

  const { authenticated, loading, user } = useAuthContext();
  const searchParams = useSearchParams();
  console.log('hi 111111111111111111')
  // const returnTo = searchParams.get('returnTo') || "/";
  const returnTo = searchParams.get('returnTo') ||  PATH_AFTER_LOGIN(routePrefix(user));
  console.log('hi 222222222222222222')

  const [open, setOpen] = useState(false);
  console.log('hi there guest guard')
  // if (authenticated) {
  //   console.log('I am here')
  //   console.log('PATH_AFTER_LOGIN(routePrefix(user)', PATH_AFTER_LOGIN(routePrefix(user)));
  //   return <Navigate to={PATH_AFTER_LOGIN(routePrefix(user))} />;
  // }

  useEffect(() => {
    if (authenticated && user?.ismfaEnabled) {
      setOpen(true);
      console.log('Hi there')
    }
  }, [authenticated, user?.ismfaEnabled]);

  if (loading) {
    console.log('In initialized')
    return <LoadingScreen />;
  }
  console.log('In authenticated',authenticated)
  if (authenticated) {
    console.log('In user',user)
    if (user?.ismfaEnabled && localStorage.getItem("MFAVerified") !== "true") {
      return <TwoFactorAuth open={open} onClose={() => setOpen(false)} />;
    } else {
      router.replace(returnTo);
    }
  }

  return <> {children} </>;
}

